var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bx_btn_switch"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_vm._v(" "),_c('button',{staticClass:"btn_switch",class:{is_active: _vm.value},on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.stateText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }